import { ghostBtnClass, mfgPrimaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { ManufacturingLaborPaysBySelect } from "./ManufacturingLaborPaysBySelect";
import type { LaborPaysBy } from "@/lib/manufacturing/laborPayQuantity";

export type UnmatchedRateNeed = "all" | "needs_pays_by" | "needs_sku";

export function ManufacturingLaborCompanyRateUnmatchedToolbar({
  need,
  onNeed,
  filteredCount,
  selectedCount,
  allFilteredSelected,
  bulkPaysBy,
  onBulkPaysBy,
  busy,
  readOnly,
  onSelectAllFiltered,
  onClear,
  onApply,
  onCreateUnconfirmed,
  selectedNeedSkuCount,
}: {
  need: UnmatchedRateNeed;
  onNeed: (next: UnmatchedRateNeed) => void;
  filteredCount: number;
  selectedCount: number;
  allFilteredSelected: boolean;
  bulkPaysBy: LaborPaysBy | "";
  onBulkPaysBy: (next: LaborPaysBy | "") => void;
  busy: boolean;
  readOnly: boolean;
  onSelectAllFiltered: () => void;
  onClear: () => void;
  onApply: () => void;
  onCreateUnconfirmed: () => void;
  selectedNeedSkuCount: number;
}) {
  return (
    <div className="mb-3 space-y-2">
      <div className="flex flex-wrap gap-1.5">
        {(
          [
            ["all", "All"],
            ["needs_pays_by", "Needs Pays by"],
            ["needs_sku", "Needs SKU"],
          ] as const
        ).map(([id, label]) => (
          <button
            key={id}
            type="button"
            className={need === id ? mfgPrimaryBtnClass : ghostBtnClass}
            disabled={busy}
            onClick={() => onNeed(id)}
          >
            {label}
          </button>
        ))}
      </div>
      {readOnly ? null : (
        <div className="flex flex-wrap items-end gap-2">
          <button
            type="button"
            className={ghostBtnClass}
            disabled={busy || filteredCount === 0 || allFilteredSelected}
            onClick={onSelectAllFiltered}
          >
            Select all filtered
          </button>
          <button type="button" className={ghostBtnClass} disabled={busy || selectedCount === 0} onClick={onClear}>
            Clear
          </button>
          <label className="block min-w-[12rem] text-xs text-gray-600 dark:text-zinc-400">
            Pays by for selected
            <ManufacturingLaborPaysBySelect value={bulkPaysBy} disabled={busy} onChange={onBulkPaysBy} />
          </label>
          <button
            type="button"
            className={mfgPrimaryBtnClass}
            disabled={busy || selectedCount === 0 || !bulkPaysBy}
            onClick={onApply}
          >
            Apply to {selectedCount || 0}
          </button>
          <button
            type="button"
            className={ghostBtnClass}
            disabled={busy || selectedNeedSkuCount === 0}
            onClick={onCreateUnconfirmed}
          >
            Create unconfirmed models ({selectedNeedSkuCount || 0})
          </button>
        </div>
      )}
    </div>
  );
}
